export default "__VITE_ASSET__1PC1LDrh__"